module.exports = __webpack_public_path__ + "img/9ffa79a.webp";